import React, { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Pencil } from "lucide-react";
import { imgSrc } from "../../lib/content";
import ListLinkEditor from "./ListLinkEditor";
import NewEventModal from "./NewEventModal";
import { fmtDate } from "./AdminUI";

function EventRow({ e, onChange, onEdit }) {
  const remove = async () => {
    if (!window.confirm("Eliminare l'evento?")) return;
    await api.delete(`/events/${e.id}`); toast.success("Evento eliminato"); onChange();
  };
  return (
    <div className="card-dark p-4 flex items-center gap-4" data-testid={`admin-event-${e.id}`}>
      <img src={imgSrc(e.poster_url)} alt="" className="w-16 h-20 object-cover"/>
      <div className="flex-1 min-w-0">
        <div className="font-display text-xl">{e.title}</div>
        <div className="font-mono text-xs text-neutral-500 tracking-widest">{fmtDate(e.date)} · {e.venue}, {e.city}</div>
        <ListLinkEditor key={e.list_url || ""} event={e} onSaved={onChange}/>
      </div>
      <button onClick={()=>onEdit(e)} className="text-neon p-1" aria-label="Modifica" data-testid={`edit-event-${e.id}`}><Pencil className="w-4 h-4"/></button>
      <button onClick={remove} className="text-alert hover:text-glow-alert" data-testid={`del-event-${e.id}`}><Trash2 className="w-4 h-4"/></button>
    </div>
  );
}

export default function EventsPanel({ events, onChange }) {
  const [showNew, setShowNew] = useState(false);
  const [editing, setEditing] = useState(null);
  return (
    <div>
      <div className="flex justify-between mb-4">
        <div className="label-mono text-neutral-500">{events.length} EVENTI</div>
        <button onClick={()=>setShowNew(true)} className="btn-primary !py-2 !px-3 text-xs flex items-center gap-1" data-testid="new-event-btn"><Plus className="w-3 h-3"/>NUOVO</button>
      </div>
      <div className="space-y-2">
        {events.map(e => <EventRow key={e.id} e={e} onChange={onChange} onEdit={setEditing}/>)}
      </div>
      {showNew && <NewEventModal onClose={()=>setShowNew(false)} onCreated={()=>{setShowNew(false); onChange();}}/>}
      {editing && <NewEventModal event={editing} onClose={()=>setEditing(null)} onCreated={()=>{setEditing(null); onChange();}}/>}
    </div>
  );
}
